import axios from 'axios';

const adminInstance = axios.create();
const automatedInstance = axios.create();

// Function to set up the admin instance with the nonce
export const setupAdminInstance = () => {
  console.log("Setting up admin instance...");
  if (window.wpAiWorkflowsSettings && window.wpAiWorkflowsSettings.nonce) {
    adminInstance.defaults.headers.common['X-WP-Nonce'] = window.wpAiWorkflowsSettings.nonce;
    console.log("Nonce set successfully:", window.wpAiWorkflowsSettings.nonce);
    
    // Set the base URL for API requests
    if (window.wpAiWorkflowsSettings.root) {
      adminInstance.defaults.baseURL = window.wpAiWorkflowsSettings.root + 'wp-ai-workflows/v1';
      console.log("Base URL set to:", adminInstance.defaults.baseURL);
    } else {
      console.warn("API root URL not found in settings.");
    }
  } else {
    console.warn("WP AI Workflows settings or nonce not found. Some features may not work correctly.");
  }

  // Add request interceptor for logging
  adminInstance.interceptors.request.use(config => {
    console.log('API Request:', config.method.toUpperCase(), config.url);
    return config;
  });

  // Add response interceptor for logging
  adminInstance.interceptors.response.use(
    response => {
      console.log('API Response:', response.status, response.config.url);
      return response;
    },
    error => {
      console.error('API Error:', error.response ? error.response.status : 'Unknown', error.config ? error.config.url : 'Unknown URL');
      return Promise.reject(error);
    }
  );
};

// Function to set the API key for automated instance
export const setApiKey = (apiKey) => {
  console.log("Setting API key for automated instance...");
  automatedInstance.defaults.headers.common['X-Api-Key'] = apiKey;
  
  // You might want to set a base URL for the automated instance as well
  // automatedInstance.defaults.baseURL = 'your_automated_api_base_url';
};

export { adminInstance, automatedInstance };